import { render, staticRenderFns } from "./_copy_record_form.vue?vue&type=template&id=238da55a&"
import script from "./_copy_record_form.vue?vue&type=script&lang=js&"
export * from "./_copy_record_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports